import { ICellRendererParams } from "ag-grid-enterprise";
import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import { MinusIcon } from "@heroicons/react/20/solid";

export function DeltaCellRenderer(params: ICellRendererParams) {
    const delta = params.value as number | null;

    if (delta === null || !Number.isFinite(delta)) {
        return <span className={clsx("body-s subdued")}>-</span>;
    }

    const changePercent = delta * 100 || 0;
    const isPositive = delta > 0;
    const isNegative = delta < 0;
    const isNeutral = delta === 0;

    const formattedPercent = changePercent.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

    return (
        <span
            className={clsx(
                "body-s hover:bg-hover flex cursor-pointer items-center gap-3",
            )}
        >
            {isPositive && (
                <ArrowUpIcon className="size-4 stroke-emerald-500" />
            )}
            {isNegative && <ArrowDownIcon className="size-4 stroke-red-500" />}
            {isNeutral && <MinusIcon className="size-4 stroke-gray-400" />}
            {formattedPercent}%
        </span>
    );
}
